<template>
	<PageHeaderLayout :isBack="true">
		<div class="main-page-content">
			<el-form ref="courseForm" :model="form" :rules="rules" label-width="120px" class="course-form">
				<el-row :gutter="16">
					<el-col :span="8">
						<el-form-item label="课程名称" prop="title">
							<el-input v-model="form.title" placeholder="请输入课程名称" :disabled="isDisabled"></el-input>
						</el-form-item>
					</el-col>
					<el-col v-show="false" :span="8">
						<el-form-item label="发布位置" prop="publishType">
							<el-select v-model="form.publishType" :multiple="!isEdit" placeholder="请选择发布位置" :disabled="isDisabled || isEdit" clearable>
								<el-option v-for="item in publishTypeList" :key="item.publish_type" :label="item.publish_name" :value="item.publish_type"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="课程状态" prop="status">
							<el-select v-model="form.status" placeholder="请选择课程状态" :disabled="isDisabled" clearable>
								<el-option label="未开始" :value="0"></el-option>
								<el-option label="进行中" :value="1"></el-option>
								<el-option label="已结束" :value="2"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="所属行业" prop="categoryId">
							<el-select v-model="form.categoryId" placeholder="请选择所属行业" :disabled="isDisabled" clearable>
								<el-option v-for="item in industryList" :key="item.id" :label="item.industry_type || item.name" :value="item.id"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="讲师名称">
							<el-input v-model="form.teacher" placeholder="请输入讲师名称" :disabled="isDisabled"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="授课形式" prop="mode">
							<el-select v-model="form.mode" placeholder="请选择授课形式" :disabled="true">
								<el-option label="线上" :value="'1'"></el-option>
								<el-option label="线下" :value="'2'"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="首页推荐" prop="isRecommend">
							<el-select v-model="form.isRecommend" placeholder="请选择是否推荐课程" :disabled="isDisabled" clearable>
								<el-option label="推荐至首页" :value="1"></el-option>
								<el-option label="否" :value="2"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="课程时间" prop="Time">
							<el-date-picker
								v-model="form.Time"
								type="datetimerange"
								value-format="yyyy-MM-dd HH:mm:ss"
								format="yyyy-MM-dd HH:mm:ss"
								range-separator="至"
								start-placeholder="开始时间"
								end-placeholder="结束时间"
								:disabled="isDisabled"
							></el-date-picker>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="副标题">
							<el-input v-model="form.subtitle" type="textarea" placeholder="请输入副标题" :disabled="isDisabled"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="培训地址">
							<el-cascader v-model="form.addressOptions" :options="addressOptions" placeholder="请选择培训地址" :disabled="isDisabled" clearable></el-cascader>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="详细地址">
							<el-input v-model="form.address" placeholder="请输入详细地址" :disabled="isDisabled"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="课程费用">
							<el-input v-model="form.price" placeholder="请输入课程费用" :disabled="isDisabled"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="联系人">
							<el-input v-model="form.contacts" placeholder="请输入联系人" :disabled="isDisabled"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="联系电话">
							<el-input v-model="form.contactsPhone" placeholder="请输入联系电话" :disabled="isDisabled"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label="课程图片">
							<UploadImg
								ref="courseImage"
								:accept="['png', 'jpg', 'jpeg']"
								:upload-props="{ limit: 1, maxSize: 2 }"
								:disabled="isDisabled"
								@successFile="handleImageSuccess"
								@removeFile="handleImageSuccess"
							/>
						</el-form-item>
					</el-col>
				</el-row>
				<el-form-item label="课程介绍" prop="content">
					<ApeEditor
						:init-html="form.content"
						:editor-height="360"
						:oss-data="ossData"
						:oss-obj="ossObj"
						@handleTinymceInput="handleTinymceInput"
					/>
				</el-form-item>
				<el-form-item v-if="!isDisabled">
					<el-button type="primary" @click="submit">{{ isEdit ? '确认' : '立刻创建' }}</el-button>
				</el-form-item>
			</el-form>
		</div>
	</PageHeaderLayout>
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import UploadImg from '@/components/uploadImg/index.vue'
import ApeEditor from '@/components/ApeEditor/ApeEditor.vue'

export default {
	name: 'CreateCourse',
	components: {
		PageHeaderLayout,
		UploadImg,
		ApeEditor
	},
	data() {
		return {
			form: this.getDefaultForm(),
			publishTypeList: [],
			industryList: [],
			addressOptions: [],
			ossData: {},
			ossObj: {},
			rules: {
				title: [{ required: true, message: '请输入课程名称', trigger: 'blur' }],
				publishType: [{ required: true, message: '请选择发布位置', trigger: 'change' }],
				status: [{ required: true, message: '请选择课程状态', trigger: 'change' }],
				categoryId: [{ required: true, message: '请选择所属行业', trigger: 'change' }],
				isRecommend: [{ required: true, message: '请选择首页推荐', trigger: 'change' }],
				Time: [{ required: true, message: '请选择课程时间', trigger: 'change' }],
				content: [{ required: true, message: '请输入课程介绍', trigger: 'blur' }]
			}
		}
	},
	computed: {
		id() {
			return this.$route.query.id
		},
		isEdit() {
			return !!this.id
		},
		isDisabled() {
			return !!this.$route.query.disabled
		}
	},
	methods: {
		getDefaultForm() {
			return {
				title: '',
				publishType: 1,
				status: '',
				categoryId: '',
				teacher: '',
				mode: '2',
				isRecommend: 2,
				Time: [],
				subtitle: '',
				addressOptions: [],
				address: '',
				price: '',
				contacts: '',
				contactsPhone: '',
				image: [],
				content: ''
			}
		},
		handleImageSuccess() {
			this.form.image = this.$refs.courseImage ? this.$refs.courseImage.getImagesList() : []
		},
		handleTinymceInput(value) {
			if (!this.isDisabled) {
				this.form.content = value
			}
		},
		getPayload() {
			const payload = { ...this.form }
			payload.startTime = payload.Time[0]
			payload.endTime = payload.Time[1]
			payload.image = Array.isArray(payload.image) ? payload.image[0] : payload.image
			payload.province = payload.addressOptions && payload.addressOptions[0]
			payload.city = payload.addressOptions && payload.addressOptions[1]
			payload.area = payload.addressOptions && payload.addressOptions[2]
			payload.publishType = 1
			delete payload.Time
			delete payload.addressOptions
			return payload
		},
		submit() {
			this.$refs.courseForm.validate(async valid => {
				if (!valid) return
				this.handleImageSuccess()
				const payload = this.getPayload()
				try {
					if (this.isEdit) {
						await this.$api.updateCourse(this.id, payload)
						this.$message.success('修改成功')
						this.getCourseDetail()
					} else {
						payload.examineStatus = 1
						await this.$api.batchCourseCreate(payload)
						this.$message.success('创建成功')
						this.$router.go(-1)
					}
				} catch (e) {
					this.$message.error(e.message || '保存失败')
				}
			})
		},
		async getCourseDetail() {
			try {
				const info = await this.$api.getCourseDetail(this.id)
				const addressOptions = [info.province, info.city, info.area].filter(Boolean)
				this.form = {
					...this.getDefaultForm(),
					title: info.title || '',
					teacher: info.teacher || '',
					price: info.price,
					originalPrice: info.originalPrice,
					Time: [info.startTime, info.endTime].filter(Boolean),
					content: info.content || '',
					status: Number(info.status),
					image: info.image ? [info.image] : [],
					categoryId: info.categoryId,
					isRecommend: Number(info.isRecommend || 2),
					contactsPhone: info.contactsPhone,
					contacts: info.contacts,
					subtitle: info.subtitle,
					addressOptions,
					address: info.address,
					publishType: 1,
					mode: info.mode || 2
				}
				this.$nextTick(() => {
					if (this.$refs.courseImage) {
						this.$refs.courseImage.setImagesList(this.form.image)
					}
				})
			} catch (e) {
				this.$message.error(e.message || '获取课程详情失败')
			}
		},
		async getCoursePublishPos() {
			try {
				this.publishTypeList = await this.$api.getCoursePublishPos()
			} catch (e) {
				this.publishTypeList = []
			}
		},
		async getIndustryList() {
			try {
				this.industryList = await this.$api.getCourseIndustryList()
			} catch (e) {
				this.industryList = []
			}
		},
		async getAreaList() {
			try {
				this.addressOptions = await this.$api.getCourseAreaList()
			} catch (e) {
				this.addressOptions = []
			}
		},
		async getOssSign() {
			try {
				const ossDir = `${this.$config.ossAppDir || ''}/bill`
				const res = await this.$api.getOssSign({ dir: ossDir })
				if (res) {
					this.ossObj = { ...res, dir: res.dir || ossDir }
					this.ossData = {
						ossAccessKeyId: res.accessid,
						policy: res.policy,
						signature: res.signature
					}
				}
			} catch (e) {
				// 富文本图片上传失败时由编辑器处理
			}
		}
	},
	mounted() {
		this.getOssSign()
		this.getAreaList()
		this.getIndustryList()
		this.getCoursePublishPos()
		if (this.isEdit) {
			this.getCourseDetail()
		}
	}
}
</script>

<style lang="scss" scoped>
.course-form {
	padding-right: 24px;
}
</style>
